import type { TextSize, VisualSize } from '$lib/types/Components/SharedTypes';

type VisualSizeNumber = Record<VisualSize, number>;
type TextSizeNumber = Record<TextSize, `${number}px`>;

export const LIST_ITEM_VISUAL_SIZE_HORIZONTAL_MAP: VisualSizeNumber = {
    xSmall: 40,
    small: 48,
    medium: 64,
    large: 80,
    xLarge: 96,
};

export const LIST_ITEM_VISUAL_SIZE_VERTICAL_MAP: VisualSizeNumber = {
    xSmall: 40,
    small: 48,
    medium: 120,
    large: 192,
    xLarge: 264,
};

export const LIST_ITEM_EMOJI_PADDING_MAP: VisualSizeNumber = {
    xSmall: 8,
    small: 8,
    medium: 24,
    large: 44,
    xLarge: 68,
};

export const TEXT_SIZE_MAP: TextSizeNumber = {
    '14px': '14px',
    small: '16px',
    medium: '20px',
};
